import apiClient from 'boot/ApiClient'

import { ApiAxiosInstance } from 'boot/ApiAxios'

console.log(apiClient)
console.log(ApiAxiosInstance.defaults)

export const login = ({ store, commit, dispatch }, creds) => {
  commit('LOGIN')

  return new Promise((resolve, reject) => {
    apiClient.post('/api/login_check', creds)
      .then(response => {
        if (response.data && response.data.token && response.data.token !== ''
          ) {
          ApiAxiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token
          commit('LOGIN_SUCCESS', response.data)
          dispatch('loggedInUserChanged')
          resolve(response)
        } else {
          console.log(response)
          reject(response)
        }
      })
      .catch(err => {
        console.log(err)
        reject(err)
      })
  })
}

export const logout = ({ commit, dispatch }, creds) => {
  commit('LOGOUT')
  return new Promise((resolve, reject) => {
    apiClient.post('/api/security/logout', creds)
      .then(response => {
        if (response.data && response.data.success && response.data.success === true &&
          response.data.username && response.data.username !== '') {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const locallogout = ({ commit, dispatch }) => {
  commit('LOGOUT')
}


export const loggedInUserChanged = function ({ dispatch }) {
  console.log('loggedInUserChanged')
}

export const reset = ({ commit }, creds) => {
  commit('LOGOUT')
}

export const changePartner = ({ commit, dispatch }, newPartner) => {
  commit('CHANGE_PARTNER', newPartner)
}
